<div class="smartphoto-list">
  <div [ngClass]="{ 'smartphoto-list__search': true, 'smartphoto-list__search--sticky': sticky }">
    @if (showGoBack) {
      <bdeo-icon (click)="resetSearch()" name="arrow-left" size="medium" color="var(--tar-grey)"></bdeo-icon>
    }

    <bdeo-input
      (input)="searchInputChange($event)"
      class="smartphoto-list__search-input"
      name="searchInput"
      type="form"
      size="small"
      variant="text"
      placeholder="{{ 'case_search_placeholder' | i18nextEager }}"
      value="{{ searchInput }}"
    >
      <bdeo-icon
        name="action-search"
        slot="prefix"
        size="small"
        color="{{ loading ? 'var(--pigeon-grey)' : 'var(--tar-grey)' }}"
      ></bdeo-icon>

      @if (searchInput.length) {
        <bdeo-icon (click)="cleanSearchInput()" name="cross-circled-cross" slot="suffix" size="small" color="var(--tar-grey)"></bdeo-icon>
      }
    </bdeo-input>
  </div>

  <div [ngClass]="{ 'smartphoto-list__filters': true, 'smartphoto-list__filters--sticky': sticky, 'elevation-2': sticky }">
    @for (filter of filters; track filter) {
      <bdeo-tag
        (click)="toggleFilter(filter.status)"
        class="smartphoto-list__filters-filter"
        size="medium"
        [text]="'statuses.' + filter.text | i18nextEager"
        type="{{ activeStatuses.includes(filter.status) ? '' : 'outline' }}"
        color="{{ activeStatuses.includes(filter.status) ? filter.color : 'pigeon-grey' }}"
        [icon]="filter.icon"
      ></bdeo-tag>
    } @empty {
      @for (item of [1, 2, 3, 4, 5, 6, 7, 8]; track $index) {
        <bdeo-skeleton-title-text [margin]="false"></bdeo-skeleton-title-text>
      }
    }
  </div>

  <div
    [ngClass]="{
      'smartphoto-list__items': smartphotoList.length || loading,
      'smartphoto-list__emptyWrapper': !smartphotoList.length && !loading
    }"
  >
    @if (!loading) {
      @for (smartphoto of smartphotoList; track smartphoto.id) {
        <app-smartphoto-card [smartphoto]="smartphoto" class="smartphoto-list__item"></app-smartphoto-card>
      } @empty {
        <div class="smartphoto-list__items-empty-container">
          <div class="smartphoto-list__animation">
            <lottie-player src="../../../assets/animations/car.json" background="transparent" speed="1" loop autoplay> </lottie-player>
          </div>
          <p class="smartphoto-list__items-empty">
            {{ 'empty_list_title' | i18nextEager }}
            <br />
            {{ 'empty_list_detail' | i18nextEager }}
          </p>
        </div>
      }
    } @else {
      @for (card of [1, 2, 3, 4]; track card) {
        <app-card-skeleton class="smartphoto-list__item"></app-card-skeleton>
      }
    }
  </div>
</div>

@if (showCreateButton) {
  <app-footer selectorForPadding=".smartphoto-list">
    <bdeo-button
      data-test-id="create-button"
      size="medium"
      type="primary"
      text="{{ 'actions.new_smartphoto' | i18nextEager }}"
      icon="plus-plus"
      iconposition="left"
      routerLink="/create"
    ></bdeo-button>
  </app-footer>
}
